export default __webpack_public_path__ + "static/media/a1.198191af.png";